import { Suspense } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { store } from './store/Store';
import Spinner from './views/spinner/Spinner';
import './utils/i18n';

import { AuthProvider } from 'src/guards/jwt/JwtContext';
import { ReactQueryProvider } from './utils/react-query';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AuthProvider>
        <BrowserRouter>
          <ReactQueryProvider>
            <App />
          </ReactQueryProvider>
        </BrowserRouter>
      </AuthProvider>
    </Suspense>
  </Provider>,
);
